import { useQuery } from '@tanstack/react-query';

import { TEAM_TASKS_VIEW_TYPES } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getInitiativesTableDataForProfileAndSummary } from 'services/task';

import { getMySummaryInitiatives, getMySummaryInitiativesTableData } from '../services';

export const useMySummaryInitiatives = ({
  employeeId,
  limit,
  offset,
  keepPreviousData = false,
  refetchOnWindowFocus = true,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.mySummary.mySummaryInitiatives, employeeId, limit, offset],
    () => getMySummaryInitiatives({ employeeId, limit, offset }),
    {
      keepPreviousData,
      refetchOnWindowFocus,
    }
  );

export const useProfileAndSummaryInitiativesList = ({
  resourceType,
  attributeFilter,
  pageType,
  limit,
  offset,
  keepPreviousData = false,
  refetchOnWindowFocus = true,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.mySummary.mySummaryInitiatives, resourceType, attributeFilter, pageType, limit, offset],
    () =>
      getInitiativesTableDataForProfileAndSummary({
        resourceType,
        attributeFilter,
        pageType,
        limit,
        offset,
      }),
    {
      keepPreviousData,
      refetchOnWindowFocus,
    }
  );

export const useInitiativeTableDataQuery = ({
  resourceType = TEAM_TASKS_VIEW_TYPES.list,
  attributeFilter,
  employeeId,
  pageType,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.InitiativeTableData, attributeFilter, employeeId],
    () =>
      getMySummaryInitiativesTableData({
        resourceType,
        attributeFilter,
        pageType,
      }),
    { enabled: Boolean(employeeId), refetchOnWindowFocus: false }
  );
